const SnippetsViewerComponent = {
    templateUrl: '/snippets/snippetsViewer.tpl.html',
    controller: 'snippetsViewerController',
    bindings: {}
};

angular.module('gw-um-submission')
    .component('uiSnippetsViewer', SnippetsViewerComponent);
